import React from 'react';
import moment from 'moment';
import { Icons, NamedLink } from '../../components';
import { getCommunityCategoryLabel, getStrapiMediaUrl } from '../../util/strapiApi';
import css from './CommunityEventCard.module.css';

const formatEventDate = (startDateTime, endDateTime) => {
  if (!startDateTime) return 'Date TBA';
  const start = moment(startDateTime);
  if (!endDateTime) return start.format('MMM D, h:mm A');

  const end = moment(endDateTime);
  if (start.isSame(end, 'day')) {
    return `${start.format('MMM D, h:mm A')} - ${end.format('h:mm A')}`;
  }
  return `${start.format('MMM D, h:mm A')} - ${end.format('MMM D, h:mm A')}`;
};

const getLocationText = event => {
  if (event?.locationText) return event.locationText;
  const parts = [event?.locationCity, event?.locationState].filter(Boolean);
  return parts.length ? parts.join(', ') : 'Location TBA';
};

function CommunityEventCard({ event }) {
  const imageUrl = getStrapiMediaUrl(event?.coverImage);
  const hostAvatarUrl = getStrapiMediaUrl(event?.hostAvatar);
  const categoryLabel = getCommunityCategoryLabel(event?.category);

  const Wrapper = event?.slug ? NamedLink : 'div';
  const wrapperProps = event?.slug ? { name: 'EventPage', params: { slug: event?.slug } } : {};

  return (
    <Wrapper {...wrapperProps} className={css.card}>
      <div className={css.cover}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={event?.title || 'Event'}
            className={css.coverImage}
            loading="lazy"
          />
        ) : (
          <span className={css.coverFallback}>Event</span>
        )}
      </div>
      <div className={css.body}>
        <span className={css.category}>{categoryLabel}</span>
        <h3>{event?.title || 'Upcoming Event'}</h3>
        <div className={css.metaRow}>
          <span>
            <Icons name="calendarDate" />{' '}
            {formatEventDate(event?.startDateTime, event?.endDateTime)}
          </span>
          <span>
            <Icons name="location" /> {getLocationText(event)}
          </span>
        </div>
        <div className={css.hostRow}>
          {hostAvatarUrl ? (
            <img src={hostAvatarUrl} alt={event?.hostName || 'Host'} />
          ) : (
            <span className={css.hostAvatarFallback}>
              <Icons name="user" />
            </span>
          )}
          <span>{event?.hostName || 'MM Community'}</span>
        </div>
      </div>
    </Wrapper>
  );
}

export default CommunityEventCard;
